import { ReactComponent as MoveToBackIcon } from 'assets/icons/toolbar/layer/moveBack.svg';
import { ReactComponent as MoveBackwardsIcon } from 'assets/icons/toolbar/layer/moveBackwards.svg';
import { ReactComponent as MoveForwardIcon } from 'assets/icons/toolbar/layer/moveForwards.svg';
import { ReactComponent as MoveToFrontIcon } from 'assets/icons/toolbar/layer/moveFront.svg';
import { checkIsMoveBackwardAllowed, checkIsMoveForwardAllowed } from 'modules/Editor/Editor.helpers';
import { WidgetDirection } from 'modules/Editor/store/infographSlice.types';

import { LayerOption } from './LayerMenu.types';

export const layerOptions: LayerOption[] = [
  {
    direction: WidgetDirection.Front,
    icon: <MoveToFrontIcon />,
    label: 'move-to-front',
    shortcuts: {
      macOs: ['ctrl', '+', 'shift', '+', '>'],
      others: ['ctrl', '+', 'shift', '+', '>'],
    },
    checkIsDisabled: ({ activeWidgetIds }) => !checkIsMoveForwardAllowed(activeWidgetIds),
  },
  {
    direction: WidgetDirection.Up,
    icon: <MoveForwardIcon />,
    label: 'move-forwards',
    shortcuts: {
      macOs: ['ctrl', '+', '>'],
      others: ['ctrl', '+', '>'],
    },
    checkIsDisabled: ({ activeWidgetIds }) => !checkIsMoveForwardAllowed(activeWidgetIds),
  },
  {
    direction: WidgetDirection.Down,
    icon: <MoveBackwardsIcon />,
    label: 'move-backwards',
    shortcuts: {
      macOs: ['ctrl', '+', '<'],
      others: ['ctrl', '+', '<'],
    },
    checkIsDisabled: ({ activeWidgetIds }) => !checkIsMoveBackwardAllowed(activeWidgetIds),
  },
  {
    direction: WidgetDirection.Back,
    icon: <MoveToBackIcon />,
    label: 'move-to-back',
    shortcuts: {
      macOs: ['ctrl', '+', 'shift', '+', '<'],
      others: ['ctrl', '+', 'shift', '+', '<'],
    },
    checkIsDisabled: ({ activeWidgetIds }) => !checkIsMoveBackwardAllowed(activeWidgetIds),
  },
];
